import Odoo_softwaretool from "../../../Assets/Oddo_ErpSystem.png";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";
import HeadingParagraphSection from "../../component/ReusablaeComponent/HeadingParagraphSection";
import Food_beverange from '../../../Assets/Food_Beverange.png';
import Food_test from '../../../Assets/f&b2.png';
import Product_inovation from '../../../Assets/f&b3.png';
import Beverage_industries from '../../../Assets/f&b4.png'
import { Helmet } from 'react-helmet';

const FoodAndBeverage = () => {
  return (
    <div>
      <Helmet>
        <title>PT KCS | Food & Beverage Industry ERP Solutions Indonesia – Jakarta, Surabaya</title>
        <meta
          name="description"
          content="PT KCS delivers comprehensive ERP solutions for Indonesia's food & beverage sector. Optimize batch production, shelf-life tracking, HACCP compliance, cold chain management, and supply chain efficiency with Infor M3, LN, and Syteline."
        />
        <meta
          name="keywords"
          content="PT KCS, PT KCS Indonesia, food and beverage ERP Jakarta, food industry software Indonesia, software industri makanan minuman, ERP pabrik makanan Indonesia, food manufacturing ERP Surabaya, beverage production ERP, Infor M3 food industry Indonesia, Infor LN food beverage, batch manufacturing software, shelf-life traceability system, lot tracking food production, expiration date management software, HACCP compliance software Indonesia, food safety compliance ERP, cold chain management software, food supply chain optimization, food recall management system, recipe management software, process manufacturing ERP Indonesia, food costing software, nutritional labeling software, food quality control ERP, food and beverage digital transformation, BPOM compliance software Indonesia, halal certification management software, food packaging management ERP, agricultural supply chain ERP, food distributor management software, consumer goods ERP Indonesia, food analytics platform, ERP industri FMCG Indonesia, fast-moving consumer goods ERP, FMCG supply chain Indonesia, pabrik minuman ERP, perusahaan makanan ERP Jakarta, food processing software Indonesia, ERP perusahaan F&B"
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>

      
      <HeaderSectionReusableComponent
        mainHeading="Keeping Production Fresh, Fast, and Flexible"
        paragragh={
          <>
            The Food & Beverage industry faces pressure to meet consumer expectations, tight deadlines, and strict quality standards. PTKCS helps with ERP solutions that provide full visibility and control over production. From recipe-based or batch manufacturing to multi-stage processing, our systems optimize scheduling, reduce downtime, and ensure consistent quality. Real-time tracking of raw materials and finished goods, along with tools for shelf-life, lot traceability, and expiration management, helps you stay agile, reduce waste, and deliver fresh products on time.
          </>
        }
        imgScr={Food_beverange}
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading="Smarter Supply Chains from Farm to Fork"
        paragraph={
          <>
            In the F&B sector, an efficient supply chain is vital to prevent spoilage and revenue loss. PTKCS transforms supply chains with ERP systems that unify procurement, warehousing, logistics, and vendor management. Gain full visibility from suppliers to distributors, with automated alerts, dynamic inventory, and advanced forecasting to prevent stockouts or overstocks. Integrated logistics tools improve delivery accuracy, while full traceability ensures you can track ingredients from source to shelf and respond instantly to recalls or quality issues.
          </>
        }
        imgsrc={Food_test}
      />
      <HeadingParagraphSection
        heading="Better Forecasting, Less Waste, More Profit"
        paragraph={
          <>
           In the F&B industry, poor forecasting can lead to both lost sales and excess inventory that spoils before it’s used. PTKCS helps food businesses make smarter decisions with ERP tools that combine sales history, seasonal patterns, promotional calendars, and market trends to produce accurate demand forecasts.
            These forecasting tools are directly linked with procurement and production planning, allowing your teams to respond proactively to changes in demand. You’ll be able to align purchasing with production and reduce the risk of overordering perishable ingredients. The result? Lower operating costs, better cash flow, and a more sustainable business model.
            Additionally, built-in analytics dashboards help identify which products are most profitable, where bottlenecks are occurring, and what areas need adjustment—so you're always running at optimal efficiency.
          </>
        }
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        reverse={false}
        heading="Compliant by Default, Safe by Design"
        paragraph={
          <>
            Food safety is a competitive advantage. PTKCS embeds compliance into every process with ERP solutions that support food safety standards and regulations. Manage certifications, audits, labeling, allergen tracking, and HACCP protocols with ease. Our systems automate batch testing, enforce quality checkpoints, and flag issues early. Full lot- and ingredient-level traceability enables quick root-cause analysis or product recalls, helping you maintain customer trust while simplifying compliance.
          </>
        }
        imgsrc={Product_inovation}
        
      />
      <Image_ContentReusableComponent
        heading="Scaling Growth Without Losing Control
"
        paragraph={
          <>
           <p> As F&B companies grow into new markets and channels, complexity rises. PTKCS helps you scale with ERP systems that provide flexibility, centralized control, and real-time visibility. Whether launching new plants, e-commerce channels, or global supply chains, our solutions offer integrated financials, production data, and performance metrics accessible anywhere. Supporting multi-location operations, multiple currencies, and multilingual interfaces, our ERP ensures consistent, efficient processes and a scalable digital foundation for seamless growth.
            </p>
          </>
        }
        imgsrc={Beverage_industries}
      />
    </div>
  );
};

export default FoodAndBeverage;
